<template>
  <el-card shadow="always" :body-style="{ padding: '20px' }">
    <div slot="header">
      <span>{{ statData.name }}</span>
    </div>
    <div ref="barChart" style="width: 100%;height:400px;"></div>
  </el-card>
</template>

<script>
import echarts from 'echarts'

export default {
  props: {
    statData: {
      type: Object
    },
    xAxisData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      myChart: null,
      options: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: []
        },
        xAxis: [
          {
            type: 'category',
            axisTick: { show: false },
            axisLabel: { show: true, interval: 0, rotate: 45 },
            data: []
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: []
      }
    }
  },
  methods: {
    async renderSize(data) {
      try {
        let tmp = []
        for (let item of data) {
          tmp = [...tmp, (item / Math.pow(1024, 3)).toFixed(2)]
        }
        return tmp
      } catch (error) {}
    },
    tooltip(params) {
      let children = ''
      for (let item of params) {
        children += `<p>${item.seriesName}：${item.data}GB</p>`
      }
      let document = `
        <div>
          <p>${params[0].name}</p>
          ${children}
        </div>
      `
      return document
    },

    chartResize() {
      this.myChart.resize({ width: 'auto' })
    },
    async initChart() {
      this.myChart ? this.myChart.clear() : ''

      this.myChart = echarts.init(this.$refs.barChart)
      this.options.xAxis[0].data = this.xAxisData
      this.options.series = await this.getSeriesData()
      this.options.legend.data = this.statData.items.map((item) => item.name)
      if (this.statData.key === 'size') {
        this.options.yAxis[0].name = '单位：GB'
        this.options.tooltip.formatter = this.tooltip
      }

      this.myChart.setOption(this.options)
    },
    async getSeriesData() {
      try {
        let seriesData = []
        let tmpData = []
        for (let item of this.statData.items) {
          if (this.statData.key === 'size') {
            tmpData = await this.renderSize(item.data)
          } else {
            tmpData = item.data
          }
          seriesData.push({
            name: item.name,
            type: 'bar',
            barGap: 0,
            label: {
              show: false,
              rotate: 90,
              align: 'left',
              verticalAlign: 'middle',
              position: 'insideBottom',
              formatter: '{a} : {c}',
              fontSize: 14
              // rich: {
              //   name: {
              //     fontSize: 16,
              //     color: '#000'
              //   }
              // }
            },
            emphasis: {
              focus: 'series'
            },
            data: tmpData
          })
        }

        return seriesData
      } catch (error) {}
    }
  },

  watch: {
    xAxisData() {
      this.initChart()
    }
  },
  mounted() {
    this.initChart()
    window.addEventListener('resize', this.chartResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.chartResize)
  }
}
</script>

<style lang="scss" scoped></style>
